import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-[900px] flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <p className="font-heading text-[56px] font-semibold leading-none text-primary-200">404</p>
        <h1 className="mt-3 font-heading text-xl font-semibold text-foreground-950">页面走丢了</h1>
        <p className="mt-2 max-w-md text-[13px] leading-6 text-foreground-500">
          你访问的地址可能已经调整。可以回到首页，或直接进入影视分类继续浏览。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-[13px] font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-[13px] text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览影视分类
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}